// @flow
import React from 'react'
import { connect } from 'react-redux'
import type { Form } from 'lib/types'
import { httpGet } from 'lib/http'
import { Template } from './Template'
import { setModal } from 'lib/modal/actions'
import LineItemForm from 'components/Forms/LineItem'
import { withRouter } from 'lib/hooks/withRouter'

type Props = {
  dispatch: Function,
  form: Form,
  location: Object,
}

class Subaccount extends React.Component {
  props: Props

  constructor(props) {
    super(props)

    this.state = {
      attachments: [],
      balance: null,
      beneficiary_name: '',
      lineItems: [],
      notes: [],
      subaccount_type: null,
      account: null,
      statement_info: null,
      asset: null,
      vehicle: null,
      created_at: null,
      updated_at: null, // Add updated_at to state
      close_date: null, // Add close_date to state
      open_date: null,
      status: null,
      loading: true,
      error: false,
    }
  }

  componentDidMount() {
    this.fetchDetails()
  }

  openNewLineItemModal = () => {
    const { number, subnumber } = this.props.location.params
    this.props.dispatch(setModal(<LineItemForm number={number} subnumber={subnumber} afterCreate={this.loadDetails} />))
  }

  fetchDetails = () => {
    const { number, subnumber } = this.props.location.params

    const subaccountUrl = `/admin/accounts/${number}/subaccounts/${subnumber}`

    httpGet(subaccountUrl)
      .then((response) => {
        const subaccount = response.data?.subaccount || response.subaccount

        if (!subaccount) {
          this.setState({ error: true, loading: false })
          return
        }

        this.loadDetails({ subaccount })
      })
      .catch(() => {
        this.setState({ error: true, loading: false })
      })
  }

  loadDetails = ({ subaccount }) => {
    const {
      attachments,
      balance,
      beneficiary_name,
      line_items,
      notes,
      subaccount_type,
      statement_info,
      asset,
      vehicle,
      account,
      created_at,
      updated_at,
      close_date,
      open_date,
      status,
    } = subaccount

    this.setState({
      attachments: attachments,
      balance: balance,
      beneficiary_name: beneficiary_name,
      lineItems: line_items,
      notes: notes,
      subaccount_type: subaccount_type,
      account: account,
      statement_info: statement_info,
      asset: asset,
      vehicle: vehicle,
      created_at: created_at,
      updated_at: updated_at,
      close_date: close_date,
      open_date: open_date,
      status: status === null ? 'pending' : status,
      loading: false,
      error: false,
    })
  }

  render() {
    const { location, dispatch } = this.props
    const { number, subnumber } = location.params

    if (this.state.loading) {
      return <div>Loading...</div>
    }

    if (this.state.error) {
      return <div>Error loading subaccount details</div>
    }

    return (
      <Template
        attachments={this.state.attachments}
        balance={this.state.balance}
        beneficiaryName={this.state.beneficiary_name}
        lineItems={this.state.lineItems}
        notes={this.state.notes}
        number={number}
        account={this.state.account}
        status={this.state.status}
        subaccount_type={this.state.subaccount_type}
        subnumber={subnumber}
        dispatch={dispatch}
        openNewLineItemModal={this.openNewLineItemModal}
        onSuccess={this.fetchDetails}
        showActions={true}
        statement_info={this.state.statement_info}
        asset={this.state.asset}
        vehicle={this.state.vehicle}
        created_at={this.state.created_at}
        updated_at={this.state.updated_at}
        close_date={this.state.close_date}
        open_date={this.state.open_date}
      />
    )
  }
}

export default withRouter(connect()(Subaccount))
